import React from "react";
import Review from "../component/review/Review";

const Reviews = () => {
  return (
    <div>
      <Review />
    </div>
  );
};

export default Reviews;
